import * as React from 'react';
import { Context, Cart, CartSlider } from '@grandvisionhq/carts-v2';
import { MediaQuery } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { PaymentFlow } from '@grandvisionhq/payments';
import { StepNames } from '../models/shared.js';

const CheckoutCart = ({ isFinishedCheckout , order , paymentFlow , orderData , currentStep ,  })=>{
    var ref1;
    const isOverviewStep = currentStep === StepNames.Overview;
    const { cart  } = Context.useCart();
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { onClick: navigateToHomePage  } = useLink({
        route: 'home'
    }, {
        replace: true
    }) || {};
    // In order to enter the checkout we need at least
    // - a valid cart in --localStorage-- apollo client
    // - a cart that contains products
    // - not be in a finished checkout
    React.useEffect(()=>{
        var ref;
        if (cart && !((ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length) && !isFinishedCheckout && paymentFlow !== PaymentFlow.QR_CODE) {
            console.error(`Cart went empty during checkout, returning to homepage`);
            navigateToHomePage === null || navigateToHomePage === void 0 ? void 0 : navigateToHomePage();
        }
    }, [
        cart,
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.length,
        isFinishedCheckout,
        paymentFlow,
        navigateToHomePage
    ]);
    if (!order && !orderData && isFinishedCheckout) {
        return null;
    }
    const Wrapper = isSmallScreen && !isOverviewStep ? CartSlider : React.Fragment;
    return /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(Cart, null));
};

export { CheckoutCart };
//# sourceMappingURL=CheckoutCart.js.map
